import React from "react";

const Chess: React.FC = () => {
  return (
    <div className="section">
      <p>
        I am an <a href="https://en.wikipedia.org/wiki/FIDE_titles#International_Master_(IM)">International Master</a> (IM) of chess.
        I've been playing since I was 5 years old, and while I don't actively play competitively anymore, I'm still very much an enthusiast and casual online player.
      </p>
    </div>
  );
};

export default Chess;
